import { Pipe, PipeTransform } from "@angular/core";
import { NgxMaskPipe } from "ngx-mask";

@Pipe({
    name: "phoneFormat"
})
export class PhoneFormatPipe implements PipeTransform {
    private maskPipe = new NgxMaskPipe();

    public transform(value: string | null | undefined): string {
        if (!value) {
            return "";
        }

        const cleaned = value.replace(/\D/g, "");

        if (cleaned.length === 10) {
            return this.maskPipe.transform(cleaned, "(000) 000-0000");
        } else if (cleaned.length === 11 && cleaned.startsWith("1")) {
            return this.maskPipe.transform(cleaned, "1 (000) 000-0000");
        } else if (cleaned.length === 7) {
            return this.maskPipe.transform(cleaned, "000-0000");
        }

        return value;
    }
}
